import React, { useEffect } from "react";
import Timeline from "./Timeline";
import { motion } from "framer-motion";
import "../styles/teamStyle.css";
import DSCLead from "./DSCLead";
import Members from "./Members";
import SubLeads from "./SubLeads";

const containerVariant = {
  hidden: {
    opacity: 0,
    y: -500,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      type: "spring",
      stiffness: 80,
    },
  },
};

const Team = () => {
  const nextPage = () => {
    let pageHeight = window.innerHeight;
    window.scrollBy(0, pageHeight);
  };
  useEffect(() => {
    // console.log(window.innerHeight);
  }, []);
  return (
    <div
      className="team-container
      container lg mx-auto
    "
    >
      <div
        className="
        team-wrapper
        h-screen
        flex
        flex-col
        justify-center
        items-center
        relative
      "
      >
        <div
          className="team-headline-wrapper
          flex
          justify-center
        "
        >
          <motion.span
            className="team-headline
            text-center
            font-medium
            text-8xl
            dark:text-white
            "
            variants={containerVariant}
            initial="hidden"
            animate="visible"
          >
            Meet Our Team
          </motion.span>
        </div>
        <div
          className="team-description-wrapper
          flex
          flex-col
          justify-center
          w-4/6
          mt-4
        "
        >
          <motion.p
            className="team-description
              font-normal
              text-center
              text-xl
              text-gray-800
              dark:text-gray-300
            "
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1, duration: 0.5 }}
          >
            We are very passionate DSC team and we strive for everyone to Learn
            and Grow together. We make sure that everybody stays together with
            us and Grow strong daily
          </motion.p>
        </div>
        <motion.div
          onClick={nextPage}
          className="next-page-button"
          initial={{ y: -2 }}
          animate={{ y: 2 }}
          transition={{ yoyo: Infinity }}
        >
          <svg
            width="60"
            height="60"
            viewBox="0 0 98 97"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M73.3079 72.9236C66.861 79.3704 58.1172 82.9922 49 82.9922C39.8828 82.9922 31.139 79.3704 24.6921 72.9236C18.2453 66.4767 14.6235 57.7329 14.6235 48.6157C14.6235 39.4985 18.2453 30.7547 24.6921 24.3079C31.139 17.861 39.8828 14.2392 49 14.2392C58.1172 14.2392 66.861 17.861 73.3079 24.3079C79.7547 30.7547 83.3765 39.4985 83.3765 48.6157C83.3765 57.7329 79.7547 66.4767 73.3079 72.9236ZM35.3268 53.1734L47.4808 65.3274C47.8837 65.7303 48.4302 65.9567 49 65.9567C49.5698 65.9567 50.1163 65.7303 50.5192 65.3274L62.6732 53.1734C63.0761 52.7705 63.3025 52.224 63.3025 51.6542C63.3025 51.0844 63.0761 50.5379 62.6732 50.135C62.2702 49.732 61.7238 49.5057 61.1539 49.5057C60.5841 49.5057 60.0376 49.732 59.6347 50.135L51.1482 58.6214L51.1512 33.4233C51.1512 32.8528 50.9246 32.3056 50.5212 31.9021C50.1177 31.4987 49.5705 31.2721 49 31.2721C48.4295 31.2721 47.8823 31.4987 47.4788 31.9021C47.0754 32.3056 46.8488 32.8528 46.8488 33.4233L46.8518 58.6214L38.3653 50.135C37.9624 49.732 37.4159 49.5057 36.8461 49.5057C36.2762 49.5057 35.7298 49.732 35.3268 50.135C34.9239 50.5379 34.6975 51.0844 34.6975 51.6542C34.6975 52.224 34.9239 52.7705 35.3268 53.1734Z"
              fill="#06062D"
            />
          </svg>
        </motion.div>
      </div>
      <DSCLead />
      <SubLeads />
      <Members />
    </div>
  );
};

export default Team;
